import { createFileRoute, redirect } from '@tanstack/react-router';

import { LAST_VISITED_AGENT_ID_KEY } from '@/constants';
import { listAgentsOptions } from '@/hooks/api';
import { withRetry } from '@/utils';

export const Route = createFileRoute('/_auth/_org/agents/')({
  beforeLoad: async ({ context: { client, queryClient } }) => {
    const { data: agents } = await withRetry({
      fn: () => queryClient.ensureQueryData(listAgentsOptions(client)),
      delay: 2000,
    });

    const lastVisitedAgentId = localStorage.getItem(LAST_VISITED_AGENT_ID_KEY);
    const agent = agents.find((a) => a.agentId === lastVisitedAgentId) ?? agents[0];

    if (agent) {
      throw redirect({
        // Temporary fix until a better way is found
        to: '/agents/$agentId/inbox',
        params: { agentId: agent.agentId },
      });
    } else {
      throw redirect({ to: '/agents/new' });
    }
  },
});
